import React__default from 'react';
import styles from './ListItem.scss.mjs';

function ListItem({
  attributes,
  children,
  style
}) {
  return /*#__PURE__*/React__default.createElement("li", Object.assign({}, attributes, {
    style: style,
    className: styles.ListItem
  }), children);
}

export { ListItem };
